
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { keyActivate } from "../../utils/a11y";

let { lambda, appname } = window.app

const EditSubscriptions = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

   // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
const[image,setImg]=useState('')
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum]= useState();
    // const [sortDirection, setSortDirection] = useState('asc');
         

     

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const {searchedFlag, setSearchedFlag,  isLoading, setIsLoading,userData, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute !== undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
             setSearchedFlag(false);
             setUserSearch("")
         }
     }, [prevRoute]);


     useEffect(() => {

       if (window.site === undefined) {
           setTimeout(() => {
               if (window.site && window.site.common && window.site.common.imageCloudfront) {
                   setImg(window.site.common.imageCloudfront)
               }
           }, 1000);
       }
       if (window.site && window.site.common && window.site.common.imageCloudfront) {
           setImg(window.site.common.imageCloudfront)
       }
   
   
   }, [window.site]);


    //  // console.log('prevRoute--->',prevRoute)
    //  // console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
     const columns = [
 
         {
             name: 'Name',
             selector: row => row?.name ?? "",
             sortable: true,
         },
         {
             name: 'User Type',
             selector: row => row?.type ?? "",
             sortable: true,
         },
         {
             name: 'Email id',
             selector: row => row?.emailid ?? "",
             sortable: true,
         },
         {
             name: 'Phone Number',
             selector: row => row?.phone ?? "",
             sortable: true,
         },
         {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },
        
 
         {
             name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
             cell: (props) => 
            //   {
                subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
            <div className="d-flex">
            {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                <a onClick={e => handleViewUser(e, props.userid)} onKeyDown={keyActivate(e => handleViewUser(e, props.userid))}
                    className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
                        className="mdi mdi-eye font-size-18"></i></a>}
            {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
                {props.userid === id ? <a
                    className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                        className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)} onKeyDown={keyActivate(e => handleEditUser(e, props.userid))}
                            className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                                className="mdi mdi-pencil font-size-18"></i></a>}</>}
        </div>
            //  }
             ,
             ignoreRowClick: true,
             allowOverflow: true,
             button: true,
         },
     ];
 
     const handlePageChange = (page) => {
        GetTimeActivity()   
         setCurrentPage(page);
       };
     
       const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()   
         setRowsPerPage(newPerPage);
       };
     
// // console.log('datattatatattatat',data)
    useEffect(() => {
        setRoute("user")
       //  GetClientDataContext()
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
       //  // userActivity();
    }, []);
//      const userActivity = () => {
//          let path = window.location.pathname.split("/");
//          const pageName = path[path.length - 1];
//          var presentTime = moment();
//          let payload;

//          payload = {
//              "userid": localStorage.getItem("userId"),
//              "pagename": pageName,
//              "pageurl": window.location.href,
//              "starttime": presentTime,
//              "useragent": JSON.parse(localStorage.getItem("loc"))

//          };


//     const previousId = localStorage.getItem("previousid");
//  const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


//          axios({
//              method: 'POST',
//              url: urlLink,
//              data: payload
//          })
//              .then(function (response) {
//                  if (response?.data?.statusCode === 200) {
//                      localStorage.setItem("previousid", response?.data?.result)
//                  }
//              });
//      }
    const GetUserData = async () => {
        GetTimeActivity()   
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // // console.log('objjjjjjjj--->',obj)
                // setActiveMenuObj(obj)

                // console.log('response?.result?.[0]', response?.result?.[0])
            }
        } catch {
            // console.log("error");
        }
    };
 

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
      
    }, []);

   //  useEffect(() => {
      

   //      // console.log("trueeeeeeeeee",searchedFlag);
   //      if (searchedFlag) { 
   //          // console.log("came") 
   //          handleSearch();
   //      } else {
   //          // console.log("called get all deals") 
   //          User();
   //      }

   //  }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        GetTimeActivity()   
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token,
        })
            .then(function (response) {
                // console.log("response", response);
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                setUser(response?.data?.result);
                setData(response?.data?.result?.data);
                global.exportExcelData = response?.data?.result?.data
                      


                setIsLoading(false);
                setUserSearch("");
                setSearchedFlag(false);
                }
            }).catch((err) => {
                // console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }



  

    const handleSearch = (e,flagggg) => {
        GetTimeActivity()   
        if(flagggg){
            setcurrentPage(1);
          } 
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if(flagggg === "normalsearch"){
            setSearchedFlag(true)
       }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
            })
                .then(function (response) {
                    if (response?.data?.result==="Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        // console.log("response", response);
                        setUser(response?.data?.result);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                      


                        setIsLoading(false)
                    }
                }).catch((err) => {
                    // console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
         //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



   //  const handleKeypress = (e) => {
   //      //it triggers by pressing the enter key
   //      GetTimeActivity()   
   //      if ((e.key === "Enter")) {
   //          setTimeout(function () {
   //              handleSearch();
   //          }, 1000);
   //      }
   //  };
    const handleAddUser = (e) => {
        GetTimeActivity()   
        navigate("/adduser");
    }

    const handleEditUser = (e, paramuserid) => {
        // console.log('paramuserid',paramuserid)
        GetTimeActivity()   
        navigate("/edituser/" + paramuserid);
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()   
        // console.log('paramuserid',paramuserid)

        navigate("/viewuser/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()   
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return(
            
            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No users were found for the searched keyword</p>
                </div> </div>
        )
    }
    const handleBack=()=>{
        navigate("/subscriptions")
    }
    const handleExport = () => {
     
              // let k = defaultData || exportExcelData
          const modifiedArray = global.exportExcelData.map(( each,i) => ({
                "S.NO":i+1,
                "NAME": each?.name ?? "",
                "USER TYPE": each?.type ?? "",
                "EMAIL ID":   typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
                "PHONE NUMBER": each?.phone ?? "" ,
                "STATUS": each?.status?? "",
              
              }));
         
            exportToExcel(modifiedArray, "data");
           
        }
        function exportToExcel(jsonData, fileName) {
            delete jsonData['_id'];
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
            //FileSaver.saveAs(data, `${fileName}.xlsx`);
            FileSaver.saveAs(data1, `UsersData.xlsx`);
            // console.log('data22222--->',data)
        }
        const customSort = (rows, selector, direction) => {
            const sortedData = rows.slice().sort((rowA, rowB) => {
              // use the selector function to resolve your field names by passing the sort comparators
              // const aField = selector(rowA);
        const aField = String(selector(rowA)).toLowerCase();

              //  const bField = selector(rowB);
          const bField = String(selector(rowB)).toLowerCase();
          
              let comparison = 0;
          
              if (aField > bField) {
                comparison = 1;
              } else if (aField < bField) {
                comparison = -1;
              }
          
              return direction === 'desc' ? comparison * -1 : comparison;
            });
          
            // Log the sorted data to the console
            // setSortedRecomData(sortedData)
            global.exportExcelData = sortedData
            // // console.log('Sorted Data------>:', sortedData);
          
            return sortedData;
          };    
    // // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              
                    <div className="main-content user-management" id="edit-subscriptions-1">

                        <div className="page-content" id="edit-subscriptions-2">
                            <div className="container-fluid" id="edit-subscriptions-3">



                                <div className="row  breadcrumb">
                                    <div className="col-lg-12">
                                    <div className="d-flex align-items-center" id="edit-subscriptions-createplan">
                                             <div className="flex-grow-1">
                                                 <h4 className="mb-2 card-title">CREATE PLAN</h4>
                                             </div>
                                             {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true &&
                                                 <div>
                                                 </div>} */}
                                                <button className="stroke-btn-style" id="back-button" onClick={handleBack}><span className="material-symbols-outlined" id="back-icon">arrow_back</span>back</button>
                                         </div>
                                    </div>
                                </div>

                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card" id="edit-subscriptions-6">
                                            <div className="card-body" id="edit-subscriptions-7">
                                         {/* Here Start Edit Subscriptions Page */}
                            <div className="col-md-9 edit-subscription-plan" id="edit-subscription-8">
      {/* PLAN NAME */}
      <div className="input-group mb-4 input-style-flex" id="edit-subscriptions-9">
        <label className="form_label label-width" id="edit-subscriptions-planname">PLAN NAME<span className="required">*</span></label>
        <input className="form-control input-width" id="edit-subscription-11" placeholder="Enter Plan Name" type="text" name="planName" />
      </div>
      {/* PLAN PRICE */}
      <div className="input-group mb-4 input-style-flex">
  <label className="form_label label-width" id="edit-subscriptions-planprice">PLAN PRICE<span className="required">*</span></label>
  <div className="d-flex gap-3 input-flex">
    {/* Monthly Price */}
    <div className="input-group input-width-1">
      <span className="input-group-text">$</span>
      <input className="form-control" id="edit-subscription-permonth" placeholder="00" type="number" name="planPriceMonth" />
      <span className="input-group-text">Per Month</span>
    </div>
    {/* Yearly Price */}
    <div className="input-group input-width-2">
      <span className="input-group-text">$</span>
      <input className="form-control" placeholder="00" type="number" name="planPriceYear" id="edit-subscriptions-peryear"/>
      <span className="input-group-text">Per Year</span>
    </div>
  </div>
      </div>
      {/* PLAN DESCRIPTION */}
      <div className="input-group mb-4 input-style-flex">
      <label className="form_label label-width">
  PLAN DESCRIPTION<span className="required">*</span><br />
  <span className="label-desc">Enter description without exceeding 50 letters</span>
</label>
        <input className="form-control input-width" placeholder="Enter Plan Description" name="planDescription" id="edit-subscriptions-planDescription" style={{ height: "70px" }}/>
      </div>
      {/* NO BRANDS */}
      <div className="input-group mb-4 input-style-flex">
        <label className="form_label label-width">NO BRANDS<span className="required">*</span></label>
        <input className="form-control input-width" placeholder="Enter No. of Brands" type="number" id="edit-subscriptions-nobrands" name="noBrands" />
      </div>
      {/* MAX NO OF STORES */}
      <div className="input-group mb-4 input-style-flex">
        <label className="form_label label-width">MAX NO OF STORES<span className="required">*</span></label>
        <input className="form-control input-width" placeholder="Enter Max No. of Stores" id="edit-subscriptions-maxnostores" type="number" name="maxStores" />
      </div>
      {/* MAX NO OF USERS */}
      <div className="input-group mb-4 input-style-flex">
        <label className="form_label label-width">MAX NO OF USERS<span className="required">*</span></label>
        <input className="form-control input-width" placeholder="Enter Max No. of Users" id="edit-subscriptions-maxnousers" type="number" name="maxUsers" />
      </div>
      {/* STATUS */}
      <div className="input-group mb-4 input-style-flex">
        <label className="form_label label-width">STATUS<span className="required">*</span></label>
        <select className="form-control input-width" id="edit-subcriptions-status" name="status">
          <option value="" disabled>Select Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
      {/* button */}
      <button className="fill-btn-style" id="edit-subscription-create1">CREATE</button>
                            </div>
                            {/* Here Stop Edit Subscriptions Page */}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <SweetAlert show={tableErrMsg}
                         custom
                         confirmBtnText="ok"
                         confirmBtnBsStyle="primary"
                         title={"Something went wrong. Please reload again."}
                         onConfirm={e => setTableErrMsg(false)}
                     >
                     </SweetAlert>
                        <Footer />

                    </div>
             


            </div>
        </>
    );
};

export default EditSubscriptions;
